export interface IGetAllGoldPrice {
  page?: number;
  pageSize?: number;
  validFromDate?: string;
  validToDate?: string;
}

export const MARKET_GOLD_PRICE_VARIABLES = {
  getAll: (params: IGetAllGoldPrice) => {
    const { page, pageSize, validFromDate, validToDate } = params;

    return {
      input: {
        ...(validFromDate && { validFromDate: validFromDate }),
        ...(validToDate && { validToDate: validToDate }),
      },
      ...(page && { skip: (page - 1) * (pageSize ?? 1) }),
      ...(pageSize && { take: pageSize }),
    };
  },
};
